import Net, { NetHook, NetInitOptions } from './util/net';
import { initReportOptions, ReportInitOptions } from './business/api/report';
import { initCommonOptions, CommonInitOptions } from './util/common-options';
export { bindService, getService } from './business/service';

export interface SetupOptions {
  netOptions: NetInitOptions;
  reportOptions: ReportInitOptions,
  commonOptions?: CommonInitOptions,
  netHook?: NetHook
}

/**
 * 初始化模块，一定要在框架初始化阶段调用
 */
export function setup(options: SetupOptions): void {
  // 初始化网络模块
  Net.init(options.netOptions);
  // 初始化上报模块
  initReportOptions(options.reportOptions);
  // 初始化平台信息
  if (options.commonOptions) {
    initCommonOptions(options.commonOptions);
  }
  if (options?.netHook?.beforeRequest) {
    Net.beforeRequest(options?.netHook?.beforeRequest);
  }
}
